import { DeepLinkType } from '@gem/models/deeplinksModel';

import { mapDeepLinkType } from 'APP/main/Modules/DeepLinkHandler/DeepLinkHandler.utils';
import { RouterParams } from 'APP/router/constants';
import { useClearGetParameters } from 'APP/router/hooks/useClearGetParameters';
import useGetParameter from 'APP/router/hooks/useGetParameter';

export interface IUseDeepLinkParamsData {
  isDeepLink: boolean;
  expired: boolean;
  type: DeepLinkType;
  entityId: string;
  channelId: string;
  parentId?: string;
}

interface IUseDeepLinkResult {
  getParams: IUseDeepLinkParamsData;
  clearGetParameters(): void;
}

export function useDeepLinkParams(): IUseDeepLinkResult {
  const isDeepLink = !!useGetParameter(RouterParams.deepLink);

  const type = mapDeepLinkType(useGetParameter(RouterParams.type)) || DeepLinkType.Unknown;
  const entityId = useGetParameter(RouterParams.entityId) || '';
  const parentId = useGetParameter(RouterParams.parentId) as string | undefined;
  const expired = !!useGetParameter(RouterParams.expired);
  const channelId = useGetParameter(RouterParams.channelId) || '';

  const clearGetParameters = useClearGetParameters(
    [
      RouterParams.deepLink,
      RouterParams.type,
      RouterParams.entityId,
      RouterParams.parentId,
      RouterParams.expired,
      RouterParams.branchMatchId,
      RouterParams.branchReferrer,
      RouterParams.source,
      RouterParams.channelId,
      RouterParams.invitationUrl,
      RouterParams.allowGuests,
    ],
    true
  );

  const getParams = {
    isDeepLink,
    type,
    entityId,
    parentId,
    expired,
    channelId,
  };

  return { getParams, clearGetParameters };
}
